import React from 'react';
import { ArrowRight } from 'lucide-react';
import SEOHead from './SEOHead';

export default function Hero() {
  const scrollToConsultation = () => {
    const consultationSection = document.getElementById('consultation');
    if (consultationSection) {
      consultationSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      // If consultation section doesn't exist, navigate to contact page
      window.location.href = '/contact';
    }
  };

  return (
    <>
      <SEOHead />
      <div className="pt-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Secure Your Business with Enterprise Grade IT Solutions
            </h1>
            <p className="text-xl text-blue-100 mb-8">
             Transform your business with cutting-edge managed IT services. Get 24/7 support, cybersecurity, and cloud solutions tailored to your needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToConsultation}
                className="group bg-red-600 text-white px-8 py-4 rounded-md hover:bg-red-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg flex items-center justify-center relative overflow-hidden"
              >
                <span className="relative z-10 flex items-center">
                  Schedule A Free Consultation
                  <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform duration-300" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-red-700 to-red-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              </button>
              <a
                href="mailto:support@ucx.co"
                className="group border-2 border-white text-white px-8 py-4 rounded-md transition-all duration-300 hover:bg-white hover:text-blue-900 transform hover:scale-105 hover:shadow-lg relative overflow-hidden text-center"
              >
                <span className="relative z-10">Contact Us</span>
                <div className="absolute inset-0 bg-white transform scale-y-0 group-hover:scale-y-100 transition-transform duration-300 origin-bottom"></div>
              </a>
            </div>
          </div>
          <div className="hidden md:block relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
            <img 
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" 
              alt="IT professionals working"
              className="rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-300 relative"
            />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}